import { pageHead } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import AdminLogin from "@/pages/admin/AdminLogin";

export const Route = createFileRoute("/admin/login")({
  head: () => pageHead("Admin \u2014 Login \u2014 Modern Fence Install", "Private Modern Fence Install account and management page.", undefined, true),
  component: AdminLogin,
});
